import * as Yup from 'yup';

export const addActivityValidationSchema = Yup.object().shape({
	contentId: Yup.string().required('value required'),
	useLinkedOrganisationData: Yup.bool().required('value required'),
	dateRecorded: Yup.date().typeError("please enter a valid date").required('value required'),
	effectiveDate:Yup.date().typeError("please enter a valid date").required('value required'),
	status: Yup.string().required('value required'),
	points: Yup.number().required('value required').min(1),
	pointCategory: Yup.string().required('value required'),
	source: Yup.object().required('value required'),
	sourceId: Yup.string().required('value required')
});